import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { cn } from 'utils/helpers';

type Props = {
  navigateLink: string;
  notificationsCount: number;
};

const NotificationsBell: React.FC<Props> = ({
  navigateLink,
  notificationsCount,
}) => {
  const navigate = useNavigate();

  return (
    <div className="relative flex items-center gap-2">
      <Bell
        className="w-10 h-10 cursor-pointer mb-1"
        onClick={() => navigate(navigateLink)}
      />
      {notificationsCount > 0 && (
        <div
          className={cn(
            'absolute top-[-0.5rem] right-[-0.1rem] flex px-2 items-center justify-center bg-[#FF6A62] rounded-[1rem]',
            notificationsCount > 9
              ? 'px-1.5 right-[-0.5rem] top-[-0.6rem]'
              : '',
          )}
        >
          <p className="text-white text-center text-[1rem] font-bold font-manrope">
            {notificationsCount}
          </p>
        </div>
      )}
    </div>
  );
};

export default NotificationsBell;
